var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Headline } from '../Headline';
export const PopoverContent = React.forwardRef(({ children, className, contentScrollHeight, noPadding, onKeyDown }, ref) => {
    const PopoverContentClassNames = classnames('Popover__content', className, {
        'Popover__content--nopadding': noPadding,
    });
    return (React.createElement("div", { style: { maxHeight: contentScrollHeight }, className: PopoverContentClassNames, onKeyDown: onKeyDown, ref: ref }, children));
});
export const PopoverFooter = (_a) => {
    var { align = 'left', children, className } = _a, props = __rest(_a, ["align", "children", "className"]);
    const PopoverFooterClassNames = classnames('Popover__footer', className, {
        'justify-content-start': align === 'left',
        'justify-content-center': align === 'center',
        'justify-content-end': align === 'right',
        'justify-content-between': align === 'space-between',
    });
    return (React.createElement("div", Object.assign({ className: PopoverFooterClassNames }, props), children));
};
export const PopoverHeader = (_a) => {
    var { align = 'left', children, className, noPadding } = _a, props = __rest(_a, ["align", "children", "className", "noPadding"]);
    const PopoverHeaderClassNames = classnames('Popover__header', className, {
        'justify-content-start': align === 'left',
        'justify-content-center': align === 'center',
        'justify-content-end': align === 'right',
        'justify-content-between': align === 'space-between',
        'Popover__header--nopadding': noPadding,
    });
    return (React.createElement(Headline, Object.assign({ size: "small", className: PopoverHeaderClassNames }, props), children));
};
export const PopoverDivider = () => React.createElement("div", { className: "Popover__divider" });
//# sourceMappingURL=components.js.map